import Loading from '../../Common/Loading';
import { useProductionTemporalChartsDataContext } from './hooks/useProductionTemporalChartsDataContext';
import { ProductionTemporalEvolution } from './ProductionTemporalEvolution';
import { ProductionByMonth } from './ProductionByMonth';
import { ProductionMonthlySeries } from './ProductionMonthlySeries';
import { ProductionPermanenceDistribution } from './ProductionPermanenceDistribution';
import { ProductionAvgPermanence } from './ProductionAvgPermanence';

export const Charts = () => {
    const { isLoading } = useProductionTemporalChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <div className="charts-side-by-side-dashboards">
                <ProductionTemporalEvolution />
                <ProductionByMonth />
            </div>
            <div className="charts-side-by-side-dashboards">
                <ProductionMonthlySeries />
                <ProductionPermanenceDistribution />
            </div>
            <div className="charts-side-by-side-dashboards">
                <ProductionAvgPermanence />
            </div>
        </>
    );
};
